// extracted by mini-css-extract-plugin
module.exports = {"radios":"styles_radios__2UCH1"};